{
  "longPressMessage": "Натиснете продължително, за да отворите предварителен преглед"
}
